import React from "react";
import dynamic from "next/dynamic";
import { TinyAreaConfig } from "@ant-design/plots";
import { useTranslations } from "next-intl";

// Import dynamically to avoid SSR issues
const TinyArea = dynamic(() => import("@ant-design/plots").then(mod => mod.TinyArea), {
  ssr: false,
});

interface TinyAreaChartProps {
  data: number[];
  color?: string;
  height?: number;
}

const TinyAreaChart = ({ data, color = "#5585F2", height = 52 }: TinyAreaChartProps) => {
  const t = useTranslations("common");
  if (!data || data.length === 0) {
    return <div className="h-[52px] flex items-center justify-center">{t("no_data_available")}</div>;
  }

  const config: TinyAreaConfig = {
    height,
    autoFit: true,
    data,
    smooth: true,
    areaStyle: {
      fill: `l(270) 0:rgba(255,255,255,0.2) 0.6:${color}40 1:${color}`,
    },
    line: {
      color: color,
      style: {
        lineWidth: 2,
      },
    },
  };

  return <TinyArea {...config} />;
};

export default TinyAreaChart;
